import React from 'react';
import { Link } from 'react-router-dom';
import logo from './logo.svg';
import mylogo from './download.svg';
export default function Navbar() {
  return (
    <nav className='navbar'>
      <div className='nav-center'>
        <Link to='/'>
          <img src={logo} alt='cocktail logo' className='logo' />
        </Link>
        <img src={mylogo} alt='mylogo' className='logo' />
        <ul className='nav-links'>
          <li>
            <Link to='/'>Home</Link>
          </li>
          <li>
            <Link to='/about'>About</Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}
